export default __webpack_public_path__ + "static/VictorMono-Light-19e0f2e68e9781b90161dc9293490f1d.woff2";